export enum Type {
    SmallBanner = 'Small banner',
    BigBanner = 'Big banner',
    Video = 'Video',
    Poll = 'Poll'
}
